<template>
  <Navigation :currentPage="'res'" />
  <div class="resDetail">
    <div class="image-container" @mousemove="handleMouseMove" @mouseleave="hideArrows" @click="handleImageClick">
      <img :src="imgUrl" :alt="res.name">
      <div class="arrow left-arrow" :class="{ visible: showLeftArrow }">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="arrow right-arrow" :class="{ visible: showRightArrow }">
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </div>
    </div>
    <ul>
      <li id="resID">
        编&emsp;号:&emsp;{{ res.id }}
        <img src="@/assets/images/Seal_Seal.png" class="seal">
      </li>
      <li>名&emsp;称:&emsp;{{ res.name }}</li>
      <li>分&emsp;类:&emsp;{{ res.familya }}&thinsp;>&thinsp;{{ res.familyb }}&thinsp;>&thinsp;{{ res.familyc }}</li>
      <li>风&emsp;格:&emsp;{{ res.style }}</li>
      <li>尺&emsp;寸:&emsp;{{ Math.floor(res.sizex / 10) }}×{{ Math.floor(res.sizey / 10) }}×{{ Math.floor(res.sizez / 10) }}cm</li>
      <li>面&emsp;数:&emsp;{{ (res.faces/10000).toFixed(2) }}w</li>
      <li>渲染器:&emsp;{{ res.engine }}</li>
    </ul>
  </div>
  <KuFooter/>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import KuFooter from '@/components/KuFooter.vue'
import axios from 'axios';

export default{
  components: { Navigation, KuFooter },
  name: 'ResDetail',

  data: function(){
    return {
        res:{},
        currentPreviewIndex: 0,
        showLeftArrow: false,
        showRightArrow: false
    };
  },

  mounted(){
    this.getResInfo()
  },

  computed: {
    imgUrl() {
      if (this.res.id) {
        return `http://www.kukulib.cn/Resources/${this.res.id}/preview/${this.res.id}_preview_${this.currentPreviewIndex}.jpg`;
      }
      return '';
    }
  },

  methods:{
    getResInfo(){
      axios
        .get('/api/res/' + this.$route.params.id)
        .then(response => {
          this.res = response.data;
          this.currentPreviewIndex = 0;
        })
    },

    handleMouseMove(event) {
      const imageContainer = event.currentTarget;
      const rect = imageContainer.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const width = rect.width;              
      this.showLeftArrow = x < width / 2;
      this.showRightArrow = x >= width / 2;
    },

    hideArrows() {
      this.showLeftArrow = false;
      this.showRightArrow = false;
    },

    handleImageClick(event) {
      const imageContainer = event.currentTarget;
      const rect = imageContainer.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const width = rect.width;
      
      if (x < width / 2) {
        this.backward();
      } else {
        this.forward();
      }
    },

    backward() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--;
      } else {
        console.log("已经是第一张预览图");
      }
    },

    forward() {
      if (this.currentPreviewIndex < 2) {
        this.currentPreviewIndex++;
      } else {
        console.log("已经是最后一张预览图");
      }
    }
  }
}
</script>

<style>

.resDetail{
  width: 1000px;
  margin: 0 auto;
  margin-top: 140px;
  display: flex;
  background-color: rgb(247, 247, 247);
}

.image-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border-radius: 4px;  
}

.image-container img{
  border-radius: 4px;   
  user-select: none; 
}

.arrow {
  position: absolute;
  top: 95%;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  display: flex;
}

.arrow.visible {
  opacity: 1;
}

.left-arrow {
  left: 15px;
}

.right-arrow {
  right: 15px;
}

.arrow svg {
  color: #f74f4a;
}

.resDetail ul{
  width: 100%;
  padding-top: 64px;
  writing-mode: vertical-lr;
}
.seal{
  position: absolute;
  width: 20px;
  height: 20px;
  margin-top: 36px;
  margin-left: -1px;
}

/* 为中文单独定义字体，并限制字符范围 */
@font-face {
  font-family: 'ChineseFont';
  src: local("KaiTi"), local("STKaiti"), local("楷体");
  unicode-range: U+4E00-9FFF; /* 中日韩统一表意文字范围 */
}

.resDetail li{
  letter-spacing: 0.1em;
  list-style: none;
  font-size: 16px;
  color: rgb(99, 117, 129);
  padding: 2px 6px;
  font-family: "KaiTi", "STKaiti", "楷体", "宋体", serif;
}
</style>